import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';

const DlpRulesGmailInline = () => {
  return (
    <DlpRules
      applyBoundShow={false}
      scanTargetShow={true}
      complianceRuleNoteShow={false}
      advancedOptionsShow={false}
      fileAdvancedOptionsShow={false}
      mipShow={false}
      showHeaderScan={true}
      showApprovedSenders={true}
    />
  );
};
export default DlpRulesGmailInline;
